import { createContext } from 'react';
export const ErrorBoundaryContext = createContext({
    didCatch: false,
    error: null,
    resetErrorBoundary: () => { },
});
//# sourceMappingURL=ErrorBoundaryContext.js.map